import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.27855e-08 4.25L12 4.25L12 5.75L-3.27855e-08 5.75L3.27855e-08 4.25Z",
		fill: "#FF3131"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 1L13 5L9 9",
		stroke: "#FF3131",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgArrowRightRed;
